/**
 * Wires the axios client to the auth store, avoiding circular imports.
 * Call this once at app boot (in main.tsx).
 */
import { setAuthProvider } from "@/api/client";
import { useAuthStore } from "@/store/authStore";

export function wireAuth(): void {
  setAuthProvider({
    getAccessToken: () => useAuthStore.getState().accessToken,
    getRefreshToken: () => useAuthStore.getState().refreshToken,
    refreshAccess: () => useAuthStore.getState().refreshAccess(),
    signOut: () => useAuthStore.getState().signOut(),
  });
}
